import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type TimeGroupingEnum,
} from "@b2bportal/core-types";
import { useScheduleChangeTimePreferences } from "@tenant/flights";
import { CheckboxCard } from "@tenant/ui";
import clsx from "clsx";

import defaultStyles from "./ScheduleChangeTimePreference.module.scss";

export interface IScheduleChangeTimePreferencesProps {
  selectedTimes: TimeGroupingEnum[];
  setSelected: (times: TimeGroupingEnum[]) => void;
}

export const ScheduleChangeTimePreferences = (
  props: IScheduleChangeTimePreferencesProps
) => {
  const COMPONENT_KEY = CoreFlightsComponent.ScheduleChangeTimePreferences;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { context, handlers } = useScheduleChangeTimePreferences(props);

  return (
    <div className={clsx(block)}>
      {context.timePreferences.map(({ grouping, label, sublabel }) => (
        <CheckboxCard
          className={cn("time-preference-checkbox")}
          checked={props.selectedTimes.includes(grouping)}
          onCheckedChange={() => handlers.selectTimePreference(grouping)}
          key={label}
        >
          <span className={cn("time-preference-label")}>{label}</span>
          <span className={cn("time-preference-details")}>{sublabel}</span>
        </CheckboxCard>
      ))}
    </div>
  );
};
